var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6666 0.666748H7.33329C3.33329 0.666748 0.666626 2.66675 0.666626 7.33342V16.6667C0.666626 21.3334 3.33329 23.3334 7.33329 23.3334H20.6666C24.6666 23.3334 27.3333 21.3334 27.3333 16.6667V7.33342C27.3333 2.66675 24.6666 0.666748 20.6666 0.666748ZM21.2933 8.78675L17.12 12.1201C16.24 12.8267 15.12 13.1734 14 13.1734C12.88 13.1734 11.7466 12.8267 10.88 12.1201L6.70663 8.78675C6.27996 8.44008 6.21329 7.80008 6.54663 7.37341C6.89329 6.94675 7.51996 6.86675 7.94663 7.21341L12.12 10.5467C13.1333 11.3601 14.8533 11.3601 15.8666 10.5467L20.04 7.21341C20.4666 6.86675 21.1066 6.93341 21.44 7.37341C21.7866 7.80008 21.72 8.44008 21.2933 8.78675Z",
    fill: "#F7971E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelop);
export default __webpack_public_path__ + "static/media/envelop.91d6301fd1db7403345e8d7dfb0a2553.svg";
export { ForwardRef as ReactComponent };